import { CheckboxComponent } from './../../../../common/form/checkbox/checkbox.component';
import { RadioGroupItemComponent } from './../../../../common/form/radio/group/item/radio-group-item.component';
import { RadioGroupComponent } from './../../../../common/form/radio/group/radio-group.component';
import { FormFieldComponent } from './../../../../common/form/field/form-field.component';
import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { TCustomOption } from '@df/module-product-configuration/model/simple/custom-options/product-configuration-configurable-product-data.service';
import { PriceComponent } from '@df/ui/price/price.component';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    standalone: true,
    imports: [FormsModule, FormFieldComponent, RadioGroupComponent, RadioGroupItemComponent, PriceComponent, CheckboxComponent],
    selector: 'product-view-custom-options',
    templateUrl: './product-view-custom-options.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewCustomOptionsComponent extends UiComponent {
    /**
     * Configuration service
     */
    protected readonly configuration = inject(ProductConfiguration);

    /**
     * Options map
     */
    protected options?: TCustomOption[];

    /**
     * Form model
     */
    @ViewChild('form', { static: true, read: NgForm })
    protected form?: NgForm;

    /**
     * Init hook
     */
    override ngOnInit(): void {
        super.ngOnInit();
        // options sync
        this.subscriptions.add(
            this.configuration.customOptions$.subscribe(options => {
                if (options !== this.options) {
                    this.setOptions(options);
                }
            })
        );
        // change detection on custom options data change
        this.subscriptions.add(
            this.configuration.customOptionsDataChange$.subscribe(data => {
                this.detectChanges();
            })
        );
        // validation trigger on submit
        this.subscriptions.add(
            this.configuration.submitBefore$.subscribe(data => {
                const form = this.form;
                if (form) {
                    form.submitAttempt = true;
                    form.ngSubmit.emit();
                }
            })
        );
    }

    protected setOptions(options?: TCustomOption[]): void {
        this.options = options;
        this.detectChanges();
    }
}
